module.exports = __webpack_public_path__ + "fonts/iconfont.68ce0e30.ttf";